/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDetail } from './UserDetail';
import {
    UserDetailFromJSON,
    UserDetailFromJSONTyped,
    UserDetailToJSON,
    UserDetailToJSONTyped,
} from './UserDetail';

/**
 * 
 * @export
 * @interface FindOneUser200Response
 */
export interface FindOneUser200Response {
    /**
     * 
     */
    data?: UserDetail;
}

/**
 * Check if a given object implements the FindOneUser200Response interface.
 */
export function instanceOfFindOneUser200Response(value: object): value is FindOneUser200Response {
    return true;
}

export function FindOneUser200ResponseFromJSON(json: any): FindOneUser200Response {
    return FindOneUser200ResponseFromJSONTyped(json, false);
}

export function FindOneUser200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneUser200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UserDetailFromJSON(json['data']),
    };
}

export function FindOneUser200ResponseToJSON(json: any): FindOneUser200Response {
    return FindOneUser200ResponseToJSONTyped(json, false);
}

export function FindOneUser200ResponseToJSONTyped(value?: FindOneUser200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UserDetailToJSON(value['data']),
    };
}

